import { Box } from '@mui/system'
import LoginBackSvg from '../../../images/loginBackSvg.svg'
import FirstTimePasswordImage from '../../../images/firstTimePassword.svg'
import ForgetPassword from './ForgetPassword'

const Index = () => (
    <Box sx={styles.root}>
      <Box sx={styles.loginContainer}>

      <ForgetPassword />
      <Box component={'img'} sx={styles.rightImage} src={FirstTimePasswordImage} />
      </Box>
      <Box component={'img'} sx={styles.backSvg} src={LoginBackSvg} />
    </Box>
)
const styles = {
  root: {
    '& header': {
      marginBottom: '0px',
    },
  },
  loginContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: { xs: 'center', sm: 'flex-start' },
    flexDirection: { xs: 'column-reverse', sm: 'row' },
    position: 'relative',
    maxHeight: { xs: '80vh', sm: '90vh' },
    py: '30px',
    px: { xs: '10px', sm: '30px' },
    gap: { xs: '10px', sm: '20px' },
  },
  backSvg: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -1,
    objectFit: 'cover',
  },
  rightImage: {
    position: 'relative',
    zIndex: '8',
    my: { xs: '10px', md: 'unset' },
    display: { xs: 'block', sm: 'block' },
    width: { xs: '100%', sm: '300px', md: '400px', lg: '600px' },
    height: { xs: '250px', sm: '100%', md: '400px', lg: '500px' },
    mt: '20px',
    pt: { xs: '0px', sm: '20px' },
  },
}

export default Index
